import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { TonConnectUIProvider, THEME } from '@tonconnect/ui-react';
import { App } from './App';
import { AppProvider } from './store/AppStore';
import './styles/global.scss';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

// TON Connect requires an absolute URL to a manifest describing this
// app (name/icon/url) — see public/tonconnect-manifest.json. Deriving
// it from location.origin means it resolves correctly on whatever
// domain this ends up deployed to, without a hardcoded URL to update.
const tonConnectManifestUrl = `${window.location.origin}/tonconnect-manifest.json`;

createRoot(container).render(
  <StrictMode>
    <TonConnectUIProvider manifestUrl={tonConnectManifestUrl} uiPreferences={{ theme: THEME.DARK }}>
      <AppProvider>
        <App />
      </AppProvider>
    </TonConnectUIProvider>
  </StrictMode>,
);
